// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"1cb3e472","583":"aa25021c"}[chunkId] + ".chunk.js";
};